var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addressMContent" },
    [
      _vm._l(_vm.AddressList, function(item, index) {
        return _vm.AddressList
          ? _c(
              "van-swipe-cell",
              {
                key: index,
                attrs: {
                  "right-width": 120,
                  "left-width": 0,
                  "stop-propagation": ""
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "billBar",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        return _vm.getAddressRepair(item)
                      }
                    }
                  },
                  [
                    _c(
                      "van-row",
                      [
                        _c(
                          "van-col",
                          { attrs: { span: "3" } },
                          [
                            index % 2 == 0
                              ? _c(
                                  "van-tag",
                                  {
                                    staticClass: "Status",
                                    attrs: { color: "#ff6d02" }
                                  },
                                  [_vm._v(_vm._s(item.tag))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            index % 2 != 0
                              ? _c(
                                  "van-tag",
                                  {
                                    staticClass: "Status",
                                    attrs: { type: "primary" }
                                  },
                                  [_vm._v(_vm._s(item.tag))]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "van-col",
                          { attrs: { span: "21" } },
                          [
                            _c(
                              "van-row",
                              [
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "address",
                                    attrs: { span: "24" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.province +
                                          item.city +
                                          item.area +
                                          item.villageName +
                                          item.address
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "statusText",
                                    attrs: { span: "18" }
                                  },
                                  [
                                    _vm._v(
                                      "用热面积：" + _vm._s(item.useArea) + "m"
                                    ),
                                    _c("sup", [_vm._v("2")])
                                  ]
                                ),
                                _vm._v(" "),
                                item.default_flag == 1
                                  ? _c(
                                      "van-col",
                                      {
                                        staticClass: "tag textR",
                                        attrs: { span: "6" }
                                      },
                                      [
                                        _c(
                                          "van-tag",
                                          {
                                            attrs: {
                                              color: "#ff6d02",
                                              plain: ""
                                            }
                                          },
                                          [_vm._v("默认")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "right" },
                  [
                    _c("van-button", {
                      attrs: { square: "", type: "danger", text: "删除" },
                      on: {
                        click: function($event) {
                          return _vm.onDelete(item)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("van-button", {
                      staticClass: "edit",
                      attrs: { square: "", type: "primary", text: "编辑" },
                      on: {
                        click: function($event) {
                          return _vm.onEdit(item)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "addAddressBtn" },
        [
          _c(
            "van-button",
            {
              attrs: { type: "primary", size: "large" },
              on: { click: _vm.addAddress }
            },
            [_vm._v("新增房屋地址")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51cd2e62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51cd2e62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddressManage/AddressManage.vue
// module id = null
// module chunks = 